import { Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { NotFoundSVG } from 'src/assets/SVG/_index'

const NotFoundedPatients: React.FC = () => {
  return (
    <VStack mt={3} spacing={2} align="center">
      <NotFoundSVG />
      <Text fontSize="18px" fontWeight={500} color="#34343F">
        Aucun Patient trouvé.
      </Text>
      <Text fontSize="14px" fontWeight={400} color="#464665">
        Veuillez vérifier vos critères de recherche.
      </Text>
    </VStack>
  )
}

export default NotFoundedPatients